<div matDialogTitle class="modal-header">
    <h3>{{ 'pages.sites_management.delete_confirmation.title' | translate }}</h3>
</div>

<mat-dialog-content>
    <p>{{ 'pages.sites_management.delete_confirmation.message' | translate: { siteName: data.siteName } }}</p>
    <p class="warning-text">
        {{ 'pages.sites_management.delete_confirmation.warning' | translate: { unityCount: data.unityCount, equipmentCount: data.equipmentCount } }}
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
        {{ 'pages.sites_management.delete_confirmation.cancel' | translate }}
    </button>
    <button mat-raised-button color="warn" (click)="onConfirm()">
        {{ 'pages.sites_management.delete_confirmation.confirm' | translate }}
    </button>
</mat-dialog-actions>
